import { render, staticRenderFns } from "./UnitMark.vue?vue&type=template&id=42d55ce3"
import script from "./UnitMark.vue?vue&type=script&lang=js"
export * from "./UnitMark.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports